import React from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { AlertTriangle, LogOut } from 'lucide-react';

/**
 * Yellow warning banner shown at the very top of any dashboard when the current
 * session is a super-admin impersonation. Provides a one-click "exit" that
 * restores the original super-admin session without needing to re-login.
 */
export default function ImpersonationBanner({ user, schoolInfo }) {
  if (!user?.impersonated_by) return null;

  const exit = async () => {
    try {
      await axios.post('/auth/exit-impersonation');
      toast.success(`Volviendo a SuperAdmin (${user.impersonated_by})...`);
      setTimeout(() => { window.location.href = '/'; }, 400);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Error al salir de la impersonación');
    }
  };

  return (
    <div
      className="w-full bg-gradient-to-r from-amber-400 to-yellow-500 text-slate-900 px-4 py-2 flex items-center justify-between shadow-md sticky top-0 z-50"
      data-testid="impersonation-banner"
    >
      <div className="flex items-center gap-2 text-sm font-semibold">
        <AlertTriangle className="w-4 h-4" />
        <span>
          🔓 Modo Soporte — Impersonando <strong>{schoolInfo?.school_name || 'esta escuela'}</strong>
          {' '}(iniciado por <span className="font-mono">{user.impersonated_by}</span>)
        </span>
      </div>
      <button
        onClick={exit}
        className="bg-slate-900 text-white px-3 py-1 rounded-md text-xs font-semibold hover:bg-slate-800 transition-colors flex items-center gap-1"
        data-testid="exit-impersonation-btn"
      >
        <LogOut className="w-3 h-3" /> Volver a SuperAdmin
      </button>
    </div>
  );
}
